import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import HeaderBar from "./@shared/HeaderBar";
import Sidebar from "./@shared/SideBar";
import DashboardPage from "./pages/dashboardPage/DashboardPage";
import DispatchCentrePage from "./pages/Dispatch-Centre/dispatchCentrePage/DispatchCentrePage";
import ReportPage from "./pages/ReportPage/ReportPage";
import { Layout, message } from "antd";
import UserAuth from "./userAuth/UserAuth";
import EOLdashboardPage from "./pages/EOLPage/EOL-dashboard/EOLdashboardPage";
import SummaryPage from "./pages/ReportPage/SummaryPage";
import NotAllowPage from "./pages/NotAllowPage/NotAllowPage";
import ActiveKanban from "./pages/ReportPage/ActiveKanban";
import ViewKanban from "./components/DispatchCentre/ViewKanban";
import ViewGarment from "./components/ManageBin/Garments/ViewGarment";
import AddKanban from "./components/ManageBin/Garments/ManageGarments/AddGarment";
import OverViewGarments from "./components/ManageBin/Garments/ManageGarments/OverViewGarments";
import EditViewGarments from "./components/ManageBin/Garments/ManageGarments/EditGarments/EditViewGarments";
import WashDashboardPage from "./pages/Wash/DashboardPage/WashDashboardPage";
import ViewBinPage from "./pages/Wash/ViewBinPage/ViewBinPage";
import BinOutwardPage from "./pages/Wash/BinOutwardPage/BinOutwardPage";
import WashReportPage from "./pages/Wash/ReportPage/WashReportPage";
import ViewBinData from "./components/Wash/ViewBin/ViewBinData";
import OutWardConfirm from "./components/Wash/BinOutward/OutWardConfirm";
import BinInwardPage from "./pages/Wash/BinInwardPage/BinInwardPage";
import BinWashingPage from "./pages/Wash/BinWashingPage/BinWashingPage";
import InWardConfirm from "./components/Wash/BinInward/InWardConfirm";
import WashingConfirm from "./components/Wash/BinWashing/WashingConfirm";
import KanbanInwardPage from "./pages/Dispatch-Centre/KanbanInwardPage/KanbanInwardPage";
import OutWardWashConfirm from "./components/Wash/BinOutward/OutWardWashConfirm";
import BinOutwardWashPage from "./pages/Wash/BinOutwardPage/BinOutwardWashPage";
import GSMInwardPage from "./pages/GSuperMarketPage/BinInwardPage/GSMInwardPage";
import GSMDashboardPage from "./pages/GSuperMarketPage/DashboardPage/GSMDashboardPage";
import GSMInwardConfirm from "./components/GSuperMarket/GSMInwatd/GSMInwardConfirm";
import EOLViewBinData from "./components/EOL/ViewBin/EOLViewBinData";
import EOLViewBinPage from "./pages/EOLPage/EOLViewPage/EOLViewBinPage";
import GSMViewBinData from "./components/GSuperMarket/GSMDashboard/GSMViewBinData";
import BinBlukOutwardPage from "./pages/Dispatch-Centre/BlukOutwardPage/BinBlukOutwardPage";
import BinBulkScan from "./components/DispatchCentre/BlukOutward/Bin/BinBulkScan";
import MasterBinPage from "./pages/Dispatch-Centre/DS_MasterBinPage/DS_MasterBinPage";
import DS_MasterBinPage from "./pages/Dispatch-Centre/DS_MasterBinPage/DS_MasterBinPage";
import EOL_MasterBinPage from "./pages/EOLPage/EOL_MasterBinPage/EOL_MasterBinPage";
import GSM_MasterBinPage from "./pages/GSuperMarketPage/GSM_MasterBinPage/GSM_MasterBinPage";
import WASH_MasterBinPage from "./pages/Wash/WASH_MasterBinPage/WASH_MasterBinPage";
import OutwaredBinPage from "./pages/ReportPage/Dispatch_Centre/OutwaredBinPage/OutwaredBinPage";
import Wash_InwardedBinPage from "./pages/Wash/ReportPage/Wash_InwardedBinPage/Wash_InwardedBinPage";
import GSM_BinStatusPage from "./pages/GSuperMarketPage/GSM_BinStatusPage/GSM_BinStatusPage";
import GSM_OutwardPage from "./pages/GSuperMarketPage/GSM_OutwardPage/GSM_OutwardPage";
import GSM_OutwardConfirm from "./components/GSuperMarket/GSM_Outward/GSM_OutwardConfirm";
import EOL_BinStatusPage from "./pages/EOLPage/EOL_BinStatusPage/EOL_BinStatusPage";
import KanbanCountAccuracyDashbaordPage from "./pages/Kanban-Count-AccuracyPage/Dashboard/KanbanCountAccuracyDashbaordPage";
import KanbanCountAccuracyKanbanScanPage from "./pages/Kanban-Count-AccuracyPage/KanbanScan/KanbanCountAccuracyKanbanScanPage";
import KCA_KanbanScanConfrim from "./components/Kanban-Count-Accuracy/SendToFinishing/KCA_KanbanScanConfrim";
import DailyReportPage from "./pages/Kanban-Count-AccuracyPage/Report/DailyReportPage/DailyReportPage";
import OutwardPreviewPage from "./pages/Dispatch-Centre/BlukOutwardPage/OutwardPreviewPage";
import ResponseMessage from "./components/Comman/Notification/ResponseMessge";
import EOLC_DashbordPage from "./pages/EOL-CheckerPage/EOLC_DashbordPage";
import ViewCardDataPage from "./pages/EOLPage/EOL-dashboard/ViewCardDataPage";
import WashBinTransitPage from "./pages/Wash/WashBinTransitPage/WashBinTransitPage";
import GSM_BinTransitPage from "./pages/GSuperMarketPage/GSM_BinTransitPage/GSM_BinTransitPage";
import ViewBinTransitPage from "./pages/Wash/WashBinTransitPage/ViewBinTransitPage";
import GSM_ViewBinTransitPage from "./pages/GSuperMarketPage/GSM_BinTransitPage/GSM_ViewBinTransitPage";
import Eolc_HourReport from "./pages/EOL-CheckerPage/Eolc_ReportPage/Eolc_HourReport/Eolc_HourReport";
// import BarcodeReviewPage from './components/EOL-Checker/EOLC-Review/BarcodReview';
import BarcodeReviewPage  from "./components/EOL-Checker/EOLC-Review/BarcodReview";
import CapaReportPage from "./components/EOL-Checker/CapaReport/CapaReport"
const { Header, Content } = Layout;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [userdata, setUserdata] = useState();

  console.log(userdata);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserdata(null);

    localStorage.removeItem("userData");
    localStorage.removeItem("isLoggedIn");

    ResponseMessage.success({ message: 'Logout Successful.!' });
  };

  return (
    <div style={{ height: "100%" }}>
      <HashRouter>
        <Routes>
          <Route path="/user-not-allow" element={<NotAllowPage userData={userdata} />} />
          {!isAuthenticated ? (
            <Route
              path="*"
              element={
                <UserAuth
                  onLoginSuccess={(userData) => {
                    setUserdata(userData.data);
                    setIsAuthenticated(true);
                  }}
                />
              }
            />
          ) : (
            <Route
              path="*"
              element={
                <Layout style={{ minHeight: "100vh", display: "flex", flexDirection: "row" }}>
                  <Sidebar
                    userData={userdata}
                    collapsed={collapsed}
                    toggleSidebar={toggleSidebar}
                    onLogout={handleLogout}
                  />
                  <Layout style={{flex: 1, display: "flex", flexDirection: "column",}}>
                    <HeaderBar
                      collapsed={collapsed}
                      toggleSidebar={toggleSidebar}
                      userData={userdata}
                    />
                    <Content
                      style={{
                        margin: "4px 8px",
                        padding: 20,
                        paddingRight:20,
                        background: "white",
                        overflow: "auto", 
                      }}
                    >
                      <Routes>
                        <Route path="/eol-dashboard" element={<EOLdashboardPage userData={userdata} />} />
                        <Route path="/eol-dashboard/view" element={<ViewCardDataPage userData={userdata} />} />
                        <Route path="/eol-dispatch-kanban" element={<ViewKanban userData={userdata} />} />
                        <Route path="/eol-dispatch-centre" element={<DispatchCentrePage userData={userdata} />} />

                        <Route path="/manage-bin" element={<DashboardPage userData={userdata} />} />
                        <Route path="/report/daily" element={<ReportPage userData={userdata} />} />
                        <Route path="/report/summary" element={<SummaryPage userData={userdata} />} />
                        <Route path="/active/kanban" element={<ActiveKanban userData={userdata} />} />
                        <Route path="/manage-bin/view-garment" element={<ViewGarment userData={userdata} />} />
                        <Route path="/manage-bin/add-garment" element={<AddKanban userData={userdata} />} />
                        <Route path="/manage-bin/view/add-garment" element={<OverViewGarments userdata={userdata} />} />
                        <Route path="/manage-bin/edit/garment" element={<EditViewGarments userdata={userdata} />} />

                        <Route path="/wash/dashboard" element={<WashDashboardPage userdata={userdata} />} />
                        <Route path="/wash/dashboard/intransit" element={<WashBinTransitPage userdata={userdata} />} />
                        <Route path="/wash/dashboard/intransit/View" element={<ViewBinTransitPage userdata={userdata} />} />
                        
                        
                        <Route path="/view-bin" element={<ViewBinPage userdata={userdata} />} />
                        <Route path="/wash/report" element={<WashReportPage userdata={userdata} />} />
                        <Route path="/view/bin" element={<ViewBinData userdata={userdata} />} />

                        <Route path="/wash/outward-bin" element={<BinOutwardPage userdata={userdata} />} />
                        <Route path="/wash/outward/bin" element={<OutWardConfirm userdata={userdata} />} />

                        <Route path="/wash/bin/sendtogsm" element={<BinOutwardWashPage userdata={userdata} />} />
                        <Route path="/wash/bin/sendtogsm/confirm" element={<OutWardWashConfirm userdata={userdata} />} />

                        <Route path="/wash/inward-bin" element={<BinInwardPage userdata={userdata} />} />
                        <Route path="/wash/inward/bin" element={<InWardConfirm userdata={userdata} />} />

                        <Route path="/wash/bin-outward" element={<BinWashingPage userdata={userdata} />} />
                        <Route path="/wash/bin/outward" element={<WashingConfirm userdata={userdata} />} />
                        <Route path="/wash/bin-master" element={<WASH_MasterBinPage userdata={userdata} />} />
                        <Route path="/wash/bin/status" element={<Wash_InwardedBinPage userdata={userdata} />} />


                        <Route path="/kanban-inward" element={<KanbanInwardPage userdata={userdata} />} />

                        <Route path="/gsm/bin/inward" element={<GSMInwardPage userdata={userdata} />} />
                        <Route path="/gsm/bin/dashboard" element={<GSMDashboardPage userdata={userdata} />} />
                        <Route path="/gsm/dashboard/transit" element={<GSM_BinTransitPage userdata={userdata} />} />
                        <Route path="/gsm/dashboard/transit/View" element={<GSM_ViewBinTransitPage userdata={userdata} />} />
                        
                        <Route path="/gsm/bin/inward/confirm" element={<GSMInwardConfirm userdata={userdata} />} />
                        <Route path="/gsm/bin/View" element={<GSMViewBinData userdata={userdata} />} />
                        <Route path="/gsm/bin-master" element={<GSM_MasterBinPage userdata={userdata} />} />
                        <Route path="/gsm/bin/status" element={<GSM_BinStatusPage userdata={userdata} />} />
                        <Route path="/gsm/outward-bin" element={<GSM_OutwardPage userdata={userdata} />} />
                        <Route path="/gsm/outward/bin" element={<GSM_OutwardConfirm userdata={userdata} />} />
                        
                        <Route path="/eol/View/bin" element={<EOLViewBinData userdata={userdata} />} />
                        <Route path="/eol/View" element={<EOLViewBinPage userdata={userdata} />} />
                        <Route path="/eol/bin-master" element={<EOL_MasterBinPage userdata={userdata} />} />
                        <Route path="/eol/bin/status" element={<EOL_BinStatusPage userdata={userdata} />} />

                        <Route path="/dispatch/bulkscan" element={<BinBlukOutwardPage userdata={userdata} />} />
                        <Route path="/dispatch/bulkscan/scan" element={<BinBulkScan userdata={userdata} />} />
                        <Route path="/dispatch/bulkscan/preview" element={<OutwardPreviewPage userdata={userdata} />} />
                        
                        <Route path="/dispatch/bin-master" element={<DS_MasterBinPage userdata={userdata} />} />
                        <Route path="/dispatch/bin/status" element={<OutwaredBinPage userdata={userdata} />} />

                        <Route path="/kca/dashboard" element={<KanbanCountAccuracyDashbaordPage userdata={userdata} />} />
                        <Route path="/kca/kanban-sent-finishing" element={<KanbanCountAccuracyKanbanScanPage userdata={userdata} />} />
                        <Route path="/kca/kanban-sent-finishing/confirm" element={<KCA_KanbanScanConfrim userdata={userdata} />} />
                        <Route path="/kca/daily-report" element={<DailyReportPage userdata={userdata} />} />

                        <Route path="/eolc/dashboard" element={<EOLC_DashbordPage userdata={userdata} />} />
                        <Route path="/report/hour-report" element={<Eolc_HourReport userdata={userdata} />} />
                       
                        <Route path="/eolc/barcodereview" element={<BarcodeReviewPage />} />
                         <Route path="/eolc/capareport" element={<CapaReportPage />} />
                      </Routes>
                    </Content>
                  </Layout>
                </Layout>
              }
            />
          )}
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
